import React from 'react'

export default function Error() {

  return (
    <div className="top-1/2 left-1/2 absolute transform -translate-x-1/2 -translate-y-1/2 py-5 px-5 ">
      <p className='text-8xl font-mono text-secondary-200 capitalize font'>
        Coming Soon!
      </p>
    </div>
  );
}